<template>
  <div class="container">
    <div class="title"><span>首页</span>>  {{info[0].name}}</div>
    <div class="yyhzbox">
      <h2>{{info[0].name}}</h2>
      <div class="wzbox" v-html="info[0].description"></div>
    </div>
  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          showHeader: false,
          info: [
            { name: '', description: '' },
            { name: '', description: '' }
          ],
          current: 1,
          total: 0
        }
    },
    methods: {
      goinfo() {
        this.$router.push({
          path: '/yyznxq'
        })
      },
      chanePage(e) {
        this.current = e
        this.list()
      },
      list() {
        server.descriptions().then((res) => {
          this.info = res.data
        })
      },
    },

    mounted(){
      document.documentElement.scrollTop = 0;
      this.list()
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;

    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .yyhzbox {
      border: 1px solid #D6D3D3;
      background-color: #FFFFFF;
      /*height: 300px;*/
      padding: 30px;
      h2 {
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #D6D3D3;
      }
      .wzbox {
        padding: 30px;
        line-height: 2rem;
        .title {
          font-size: 20px;
          color: #CB0E07;
        }
        .js {
          line-height: 34px;
          text-indent:2em;
          margin: 10px 0;
        }
        .imgbox {
          padding: 20px;
          img {
            display: inline-block;
            margin: 0 10px;
          }
        }
      }
    }

  }

</style>
